/* eslint-disable */
import MomentUtils from '@date-io/moment';
import FuseAuthorization from '@fuse/core/FuseAuthorization';
import React, { lazy, Suspense, useEffect, useState } from 'react';
// import FuseLayout from '@fuse/core/FuseLayout';
import FuseTheme from '@fuse/core/FuseTheme';
import history from '@history';
import { createGenerateClassName, jssPreset, StylesProvider } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { create } from 'jss';
import jssExtend from 'jss-plugin-extend';
import rtl from 'jss-rtl';
import Provider from 'react-redux/es/components/Provider';
import { Router } from 'react-router-dom';
import AppContext from './AppContext';
import { Auth } from './auth';
import routes from './fuse-configs/routesConfig';
import store from './store';
import CallContext from './store/contexts/CallContext';
import PBXCallContext from './store/contexts';
import { DownloadsProvider } from './store/contexts/DownloadsContext';
import { FacebookUploadsProvider } from './store/contexts/FacebookUploadsContext';
import { NotificationsProvider } from './store/contexts/NotificationsContext';
import NotificationsSidebar from './fuse-layouts/shared-components/NotificationsSidebar';
import NotificationToast from './fuse-layouts/shared-components/NotificationToast';
import IdleTimeoutDialog from './fuse-layouts/shared-components/IdleTimeoutDialog';
import { AlertModalProvider } from '../allGlobalComponents/AlertModalProvider';

const FuseLayout = React.lazy(() => import('@fuse/core/FuseLayout'));

const jss = create({
	...jssPreset(),
	plugins: [...jssPreset().plugins, jssExtend(), rtl()],
	insertionPoint: document.getElementById('jss-insertion-point')
});

const generateClassName = createGenerateClassName();

const App = () => {
	const [hasPermission, setHasPermission] = useState(null);

	// window.addEventListener("storage", e => {
	// 	let userToken = localStorage.getItem("user_token")
	// 	if (!userToken && window.location.pathname !== "/login") {
	// 		window.location.reload()
	// 	}
	// })
	// useEffect(() => {
	// 	const user_acl = localStorage.getItem('user_acl')
	// 	setHasPermission(user_acl)
	// });

	useEffect(() => {
		const storageHandler = e => {
			// Only a change to the session token means "logged out in another tab". Reacting
			// to every key made any page without a user_token reload whenever another tab of
			// the same origin wrote anything - two open copies of the public /apps/whatsapp
			// page reloaded each other forever. e.key is null when the store is cleared.
			if (e.key !== null && e.key !== 'user_token') return;

			let userToken = localStorage.getItem('user_token');
			if (!userToken && window.location.pathname !== '/login') {
				window.location.reload();
			}
		};
		window.addEventListener('storage', storageHandler);
		return () => window.removeEventListener('storage', storageHandler);
	}, []);

	useEffect(() => {
		const user_acl = localStorage.getItem('user_acl');
		setHasPermission(user_acl);
	}, []);

	return (
		<AppContext.Provider
			value={{
				routes
			}}
		>
			<StylesProvider jss={jss} generateClassName={generateClassName}>
				<Provider store={store}>
					<MuiPickersUtilsProvider utils={MomentUtils}>
						<Auth>
							<Router history={history}>
								<FuseAuthorization hasPermission={hasPermission}>
									<FuseTheme>
										{/* <FuseLayout /> */}
										{/* // <div className="bg-transparent flex flex-1 items-center justify-center h-full"> */}
										{/* <FuseLoading /> */}
										{/* // </div> */}
										<Suspense
											fallback={
												<>
													<div id="fuse-splash-screen">
														<div className="center">
															<div className="logo">
																<img
																	width="100%"
																	loading="lazy"
																	src="assets/images/logos/01-05.png"
																	alt="logo"
																/>
															</div>
															<div className="spinner-wrapper">
																<div className="spinner">
																	<div className="inner">
																		<div className="gap"></div>
																		<div className="left">
																			<div className="half-circle"></div>
																		</div>
																		<div className="right">
																			<div className="half-circle"></div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</>
											}
										>
											<AlertModalProvider>
												<DownloadsProvider>
													<FacebookUploadsProvider>
														<NotificationsProvider>
															<CallContext>
																<PBXCallContext>
																	<FuseLayout />
																	<NotificationsSidebar />
																	<NotificationToast />
																	<IdleTimeoutDialog />
																</PBXCallContext>
															</CallContext>
														</NotificationsProvider>
													</FacebookUploadsProvider>
												</DownloadsProvider>
											</AlertModalProvider>
										</Suspense>
									</FuseTheme>
								</FuseAuthorization>
							</Router>
						</Auth>
					</MuiPickersUtilsProvider>
				</Provider>
			</StylesProvider>
		</AppContext.Provider>
	);
};

export default App;
